import { render, staticRenderFns } from "./SalesGrid.vue?vue&type=template&id=0f9f2102&scoped=true&"
import script from "./SalesGrid.vue?vue&type=script&lang=js&"
export * from "./SalesGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9f2102",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Ampps\\www\\kaffa_machine\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f9f2102')) {
      api.createRecord('0f9f2102', component.options)
    } else {
      api.reload('0f9f2102', component.options)
    }
    module.hot.accept("./SalesGrid.vue?vue&type=template&id=0f9f2102&scoped=true&", function () {
      api.rerender('0f9f2102', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/resources/components/SalesGrid.vue"
export default component.exports